/**
 * Capability Paths
 *
 * Paths whose URL carries a capability token, such as the 90-day unsubscribe
 * link. On these paths the app boots no providers, analytics, tag manager,
 * consent surface or error reporting, because each of them would copy the URL
 * to a third party or send the visitor away from the page. Any future page with
 * a token in its URL adds its pattern here.
 *
 * No imports, so the light consent entrypoint can use it.
 */

const CAPABILITY_PATHS = [/^\/unsubscribe\/[^/]+\/?$/];

/**
 * Whether a path carries a capability token.
 *
 * @param pathname - the path to test; defaults to the current page
 * @returns true when the path matches a capability pattern
 */
export function isCapabilityPath(
  pathname: string = window.location.pathname,
): boolean {
  return CAPABILITY_PATHS.some((pattern) => pattern.test(pathname));
}
